// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1rGMn","text":"SelectPayment_text__mXDcN","title":"SelectPayment_title__3_t5s","btn":"SelectPayment_btn__20d5k"};